import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ClassesConfig, FacilityConfig } from 'src/environments/environment.interface';

@Component({
    selector: 'app-classes',
    templateUrl: './classes.component.html',
    styleUrls: ['./classes.component.scss']
})
export class ClassesComponent implements OnInit {
    settings: FacilityConfig;
    classesConfig: ClassesConfig;

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        private _environmentService: EnvironmentService,
        private _router: Router
    ) { 
        this.settings = this._environmentService.getFacilityConfig();
        this.classesConfig = this.settings.homePage.classes;
    }

    ngOnInit(): void {}

    onClick(navPage: string) {
        this._router.navigateByUrl('/class-schedule');
    }
}